const DOMAINS = [
  "gmail.com", "hotmail.com", "outlook.com", "yahoo.com", "icloud.com", "live.com",
  "aol.com", "msn.com", "me.com", "protonmail.com", "proton.me", "gmx.com", "mail.com",
  "hotmail.es", "yahoo.es", "outlook.es", "yahoo.com.mx", "hotmail.co.uk", "yahoo.co.uk",
];
const TLD_FIXES = { con: "com", cmo: "com", ocm: "com", vom: "com", xom: "com", comm: "com", om: "com", cm: "com" };
const VALID_TLDS = new Set(["com", "net", "org", "es", "fr", "de", "it", "co", "mx", "uk", "me", "io", "ar", "cl", "pe", "br", "pt", "ca", "us", "edu", "gov", "info", "nl", "be", "ch", "at"]);

// Damerau (optimal string alignment) distance — a swap like "gmial" counts as 1.
function distance(a, b) {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
}

export function suggestEmail(email) {
  const value = (email || "").trim();
  const at = value.lastIndexOf("@");
  if (at < 1) return null;
  const local = value.slice(0, at);
  const domain = value.slice(at + 1).toLowerCase();
  if (domain.length < 3 || DOMAINS.includes(domain)) return null;

  if (!domain.includes(".") && DOMAINS.includes(`${domain}.com`)) return `${local}@${domain}.com`;

  const dot = domain.lastIndexOf(".");
  const tld = dot > 0 ? domain.slice(dot + 1) : "";
  // A real TLD (e.g. yahoo.fr) is trusted: only fix the name part against same-TLD domains.
  const sameTld = VALID_TLDS.has(tld) && !TLD_FIXES[tld];
  let best = null;
  let bestDist = 3;
  for (const d of DOMAINS) {
    if (sameTld && !d.endsWith(`.${tld}`)) continue;
    const dist = distance(domain, d);
    if (dist < bestDist) { best = d; bestDist = dist; }
  }
  if (best) return `${local}@${best}`;

  const fix = TLD_FIXES[tld];
  return fix ? `${local}@${domain.slice(0, dot)}.${fix}` : null;
}
